import React from "react";
import { Route } from "react-router-dom";

const TeamsRoute = (props) => {
    document.title = props.pageTitle;

    return (
        <Route {...props}>
            {props.children}
        </Route>
    );
}

export default TeamsRoute;